import { cn } from '@eo/shared';

import { barPercent } from './helpers';
import type { LoadBarProps } from './types';

// A bullet bar: filled segments against a rail, a solid tick for the target
// and a dotted tick for where the fill should be today. Every proportion comes
// from the values passed in; the label carries the same reading in words.
export function LoadBar({ segments, scale, target, pace, label }: LoadBarProps) {
  return (
    <div
      role="img"
      aria-label={label}
      title={label}
      className="relative h-3 w-full rounded-[4px] bg-capacity-rail"
    >
      <div className="absolute inset-y-0 left-0 flex w-full gap-[2px]">
        {segments
          .filter((s) => s.hours > 0)
          .map((s) => (
            <div
              key={s.key}
              className={cn('h-full first:rounded-l-[4px] last:rounded-r-[4px]', s.className)}
              style={{ width: barPercent(s.hours, scale) }}
            />
          ))}
      </div>
      {target !== undefined && target > 0 && (
        <div
          className="absolute -inset-y-1 w-[2px] bg-text-primary"
          style={{ left: barPercent(target, scale) }}
        />
      )}
      {pace !== undefined && pace > 0 && (
        <div
          className="absolute -inset-y-1 border-l-2 border-dotted border-text-tertiary"
          style={{ left: barPercent(pace, scale) }}
        />
      )}
    </div>
  );
}
